module.exports = __webpack_public_path__ + "img/sliders-simple.5bf77754.svg";